import { FormElementModel } from '@/components/addons/registration/types';

export class SdkFormFieldModel {
  #model: FormElementModel;

  constructor(formField: FormElementModel) {
    this.#model = formField;
  }

  public get id(): number {
    return Number(this.#model.state.id);
  }

  public get label(): string | undefined {
    return this.#model.state.label;
  }

  public get type(): string | undefined {
    return this.#model.state.inputHtmlType;
  }

  public get value(): string | undefined {
    return this.#model.getStringifiedValue();
  }

  public set value(value: string | undefined) {
    this.#model.state.value = this.#model.parseStringValue(value ?? '');
  }

  public set valid(value: boolean) {
    try {
      if (typeof value !== 'boolean') {
        throw new TypeError(`[SDK] ${value} is not typeof boolean.`);
      }
      this.#model.state.isValid = value;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
}
